module.exports = __webpack_public_path__ + "static/match-doctors-704ff1f6c06d0868f7aeab66859270f8.png";